import { Provider } from "./provider";

export const ChatsContext = {
  Provider,
};

export { useChatsContext } from "./useChatsContext";